import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CalculateIcon(props: IconProps) {
    return <Icon {...props} iconKey={"calculate"}/>
}
